import React from 'react'
import logo from '../../assets/img/bekhan-logo.png'
import './AboutUs.css'
function AboutUs() {
  return (
    <div>
      <div className='container'>
        <img src={logo} alt='bekhan' />
        <h4>1.0</h4>
      </div>
    </div>
  )
}

export default AboutUs